import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useActivateAccount } from "./api";
import warningIcon from "../../assets/warning_icon.svg";
import successIcon from "../../assets/success_icon.svg";

export default function ActivateAccount() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const navigate = useNavigate();

  const { data, error, isLoading } = useActivateAccount(token);

  // Redirect to login if activated (or already active)
  useEffect(() => {
    if (data?.success) {
      const t = setTimeout(() => navigate("/log-in?activated=1"), 3000);
      return () => clearTimeout(t);
    }
  }, [data, navigate]);

  // Redirect to NotActivated if activation link expired
  useEffect(() => {
    if (data && !data.success && data.expired) {
      navigate("/not-activated", { state: { email: data.email } });
    }
  }, [data, navigate]);

  return (
    <div className='flex items-center justify-center bg-gray-50 px-4 h-[calc(100vh-6rem)]'>
      <div className='w-full max-w-md bg-white rounded-xl shadow-lg p-8 text-center'>
        {/* Loading state */}
        {isLoading && (
          <h1 className='mt-6 text-lg font-semibold'>
            Verifying your account…
          </h1>
        )}

        {/* Success - account activated */}
        {data?.success && !data?.alreadyActive && (
          <>
            <img src={successIcon} alt='Success Icon' className='h-20 w-20 mx-auto mb-4' />
            <h1 className='mt-6 text-lg font-semibold'>Account activated!</h1>
            <p className='text-sm text-gray-500 mt-2'>
              Redirecting you to the login page…
            </p>
          </>
        )}

        {/* Already activated account */}
        {data?.success && data?.alreadyActive && (
          <>
            <img src={successIcon} alt='Success Icon' className='h-20 w-20 mx-auto mb-4' />
            <h1 className='mt-6 text-lg font-semibold'>Account already activated</h1>
            <p className='text-sm text-gray-500 mt-2'>
              Your account is already active. Redirecting to the login page...
            </p>
          </>
        )}

        {/* Other errors */}
        {error && !data?.expired && (
          <>
            <img src={warningIcon} alt='Warning Icon' className='h-20 w-20 mx-auto mb-4' />
            <h1 className='mt-6 text-lg font-semibold'>Activation failed</h1>
            <p className='text-sm text-gray-500 mt-2'>
              {(error as any).response?.data?.message || "Invalid activation token"}
            </p>
            <button
              onClick={() => navigate("/log-in")}
              className='mt-6 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600'
            >
              Back to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
